"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatRequestTimeout =
/*#__PURE__*/
function (_pb_1$GuestChatReques) {
  _inherits(ExtendedGuestChatRequestTimeout, _pb_1$GuestChatReques);

  function ExtendedGuestChatRequestTimeout(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatRequestTimeout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatRequestTimeout).call(this, properties));
    _this.type = ExtendedGuestChatRequestTimeout.type;
    _this.chreqid = properties.request.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedGuestChatRequestTimeout, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.request.staff).concat(ExtendedGuestChatRequestTimeout.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatRequestTimeout.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatRequestTimeout(pb_1.GuestChatRequestTimeout.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatRequestTimeout;
}(pb_1.GuestChatRequestTimeout);

ExtendedGuestChatRequestTimeout.type = "GuestChatRequestTimeout";
ExtendedGuestChatRequestTimeout.context = "/guest-chat/cancel/timeout";
exports.GuestChatRequestTimeout = ExtendedGuestChatRequestTimeout;